import React, { useContext } from 'react';
import Container from '../../common/components/Container/Container';
import withRouteAnalytics from '../../services/analytics/withRouteAnalytics';
import { Screens } from '../../services/analytics/screens';
import TokenActiveDefault from './TokenActive/TokenActiveDefault';
import { GatekeeperNetworkServiceContext } from '../../providers/GatekeeperNetworkService/GatekeeperNetworkServiceContext';
import { getGknValue } from '../../providers/GatekeeperNetworkService/utils';
import TokenActiveMinimal from './TokenActive/TokenActiveMinimal';

function TokenActiveScreen(): JSX.Element {
  const { gknServiceData } = useContext(GatekeeperNetworkServiceContext);
  // tokenActiveDisplay can be 'default', 'minimal' or 'hide'. We only care about the first two but want to default to 'default'
  const displayMinimal = (getGknValue<string>(gknServiceData!, 'tokenActiveDisplay') || 'default') === 'minimal';

  return <Container>{displayMinimal ? <TokenActiveMinimal /> : <TokenActiveDefault />}</Container>;
}
export default withRouteAnalytics(TokenActiveScreen, Screens.TOKEN_ACTIVE);
